import AdminInstance from 'modules/admin/repository';
import { SessionService } from 'modules/session/sessionService';

export function stopImpersonate() {
  return AdminInstance.impersonateUser('stop').then((user) => {
    SessionService.saveUser(user);
  });
}
